<template>
  <div class="f-column">
    <div class="subcription-section f-column">
      <div class="subcription-section_inner">
        <div class="logo mt-4">
          <Logo />
        </div>
        <div class="title-headline mx-auto mt-8 text-center px-2">
          <span :class="{ 'anim-underline': animateUnderline }">
            <span class="anim-underline_text">
              {{ $t('subscription.start_crushing_your_competition_0') }}</span
            >
          </span>
          {{ $t('subscription.start_crushing_your_competition_1') }}
        </div>

        <div
          class="gameformat-groups mt-6 position-relative"
          :class="{ 'groups-sticky': !gm_type }"
        >
          <div
            v-for="group in groups"
            :key="group.id"
            v-ripple
            class="gameformat-groups_group text-center anim-bosunce d-flex"
            :data-tst="`gf_group_${group.id}`"
            :class="[
              group.id,
              {
                'gm-active': group.id === gm_type,
              },
            ]"
            @click="selectgm_type(group.id), scrollToAnchor()"
          >
            <div class="f-center mx-auto position-relative text-nowrap">
              <div
                v-if="group.id === 'cash'"
                class="gameformat-groups_group_title-top"
              >
                {{ $t(`gametypes.9max_6max_hu`) }}
              </div>
              <div
                v-if="group.id === 'spins'"
                class="gameformat-groups_group_title-top"
              >
                {{ $t(`gametypes.husng`) }} &
              </div>
              {{ group.display_name }}
            </div>
          </div>

          <transition name="fade-in">
            <div
              v-if="!gm_type"
              class="focus-here"
            >
              <div>
                <div class="arrow-up"></div>
                <div class="arrow-up"></div>
              </div>
              <span class="mx-8 weight_500 text-center z-index_3">
                {{ $t('subscription.select_game_to_buy') }}
              </span>
              <div>
                <div class="arrow-up"></div>
                <div class="arrow-up"></div>
              </div>
            </div>
          </transition>

          <div
            ref="anchor"
            style="position: absolute; top: 75%"
          ></div>
        </div>

        <div
          class="position-relative mt-4 z-index_3 mx-auto transition_03 w-100"
          :class="'inner_' + gm_type"
        >
          <div
            :class="{ 'opacity_2 no-events': !gm_type }"
            class="anim-fasde-in"
          >
            <AffiliateMessage
              v-if="anyCheapPlan.discount && smallScreen"
              class="mt-2 anim-fade-in_super-slow"
              :cheapPlan="anyCheapPlan"
            />

            <div
              ref="planBoxes"
              class="plan-boxes plan-boxes-top mt-2"
              @mouseenter="onceHovered = true"
            >
              <PlanBox
                v-for="plan in boxPlans"
                :id="plan.id"
                :key="plan.title"
                :data-tst="`plan_box_${plan.id}`"
                :isCurrentPlan="plan.isCurrentPlan"
                :title="plan.title"
                :btnText="plan.btnText"
                :subtitle="plan.subtitle"
                :features="plan.features"
                :managePlan="plan.managePlan"
                :plan="plan"
                :startingAtPrice="plan.startingAt && smallScreen"
                :hasTagSoon="plan.hasTagSoon"
                :onceHovered="onceHovered"
                :hasAiBtnSlot="plan.hasAiBtnSlot"
                :style="plan.css_style || ''"
                :class="[
                  { 'no-bold': plan.noBold },
                  { 'b-light': !plan.renderSlot },
                  { 'b-box-dark b-rounded': plan.renderSlot },
                  { 'b-rounded': plan.style_rounded },
                ]"
              >
                <div
                  v-if="plan.renderSlot"
                  class="f-column"
                  style="gap: 0.75rem"
                >
                  <div>
                    <div class="text-large weight_700 uppercase position-relative mr-auto">
                      6max straddle + ante
                    </div>
                    <div class="d-flex f-wrap">
                      <div
                        v-for="item in ['0.1BB Ante per player', '50-400BB']"
                        :key="item"
                        class="tier-tag-straddle text-normal mr-1 mt-1 px-2 pa-1"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="text-large weight_700 uppercase position-relative mr-auto">
                      8MAX STRADDLE + ante
                    </div>

                    <div class="d-flex f-wrap">
                      <div
                        v-for="item in ['0.5BB Ante per player', '50-1600BB']"
                        :key="item"
                        class="tier-tag-straddle text-normal mr-1 mt-1 px-2 pa-1"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="text-large weight_700 uppercase position-relative mr-auto">
                      8max straddle
                    </div>

                    <div class="d-flex f-wrap">
                      <div
                        v-for="item in ['50-400BB']"
                        :key="item"
                        class="tier-tag-straddle text-normal mr-1 mt-1 px-2 pa-1"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="text-large weight_700 uppercase position-relative mr-auto">
                      8max double straddle
                    </div>

                    <div class="d-flex f-wrap">
                      <div
                        v-for="item in ['100-1600BB']"
                        :key="item"
                        class="tier-tag-straddle text-normal mr-1 mt-1 px-2 pa-1"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="text-large weight_700 uppercase position-relative mr-auto">
                      8max mississippi
                    </div>

                    <div class="d-flex f-wrap">
                      <div
                        v-for="item in ['100-800BB']"
                        :key="item"
                        class="tier-tag-straddle text-normal mr-1 mt-1 px-2 pa-1"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="text-large weight_700 uppercase position-relative mr-auto">
                      4max ante
                    </div>

                    <div class="d-flex f-wrap">
                      <div
                        v-for="item in ['0.75BB per player', '20-200BB']"
                        :key="item"
                        class="tier-tag-straddle text-normal mr-1 mt-1 px-2 pa-1"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="text-large weight_700 uppercase position-relative mr-auto">
                      7max ante
                    </div>

                    <div class="d-flex f-wrap">
                      <div
                        v-for="item in ['0.1BB per player', '20-200BB']"
                        :key="item"
                        class="tier-tag-straddle text-normal mr-1 mt-1 px-2 pa-1"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>

                <template #ai_btn>
                  <a
                    v-if="plan.hasAiBtnSlot && !$i18n.g1"
                    href="https://blog.gtowizard.com/introducing-gto-wizard-ai/"
                    target="_blank"
                    style="
                      --clr-back: var(--clr-black-14);
                      --clr-hover-white: var(--clr-black-11);
                      color: var(--clr-black-0);
                      border: 1px solid var(--clr-black-0);
                      --height: 2.5rem;
                    "
                    class="gw_btn gw_btn_outline mt-4"
                  >
                    <!-- color: var(--clr-black-0); -->
                    Read more about AI solving here
                  </a>
                </template>
              </PlanBox>
            </div>
            <AffiliateMessage
              v-if="anyCheapPlan.discount"
              class="mt-4"
              :cheapPlan="anyCheapPlan"
            />
            <div
              class="f-center feature-list mt-4"
              large
              @click="scrollToFeatures"
            >
              {{ $t('subscription.see_all_features') }}
              <v-icon>mdi-chevron-down</v-icon>
            </div>

            <AllFeaturesTable
              ref="featuresTable"
              class="mt-4"
            >
              <div
                v-if="!mobile && gm_type"
                class="d-flex plan-boxes plan-boxes_left"
              >
                <PlanBox
                  v-for="plan in boxPlans.filter(i => !i.renderSlot)"
                  :id="plan.id"
                  :key="plan.title"
                  :isCurrentPlan="plan.isCurrentPlan"
                  :managePlan="plan.managePlan"
                  :title="plan.title"
                  :plan="plan"
                  :btnText="plan.btnText"
                  :style="plan.css_style || ''"
                  class="plan-box btn-to-bottom b-light p-slim"
                />
              </div>
            </AllFeaturesTable>

            <div class="early-bird-message f-column mb-16">
              <div
                v-if="!smallScreen"
                class="plan-boxes plan-boxes_left mt-4"
              >
                <PlanBox
                  v-for="plan in boxPlans.filter(i => !i.renderSlot)"
                  :id="plan.id"
                  :key="plan.title"
                  :isCurrentPlan="plan.isCurrentPlan"
                  :managePlan="plan.managePlan"
                  :title="plan.title"
                  :btnText="plan.btnText"
                  :subtitle="plan.subtitle"
                  :startingAtPrice="plan.startingAt"
                  :plan="plan"
                  class="plan-box btn-to-bottom b-light"
                  style="--header-flex: 1"
                >
                </PlanBox>
              </div>
              <AffiliateMessage
                v-if="anyCheapPlan.discount"
                class="moved-left mt-4 mb-2"
                :cheapPlan="anyCheapPlan"
              />

              <div
                class="moved-left f-center text-center pa-2 weight_500 mt-2 text-grey clr-back-black-opacity b-radius_4"
                style="
                  background-color: rgba(0, 0, 0, 0.3);
                  color: var(--clr-grey-3);
                  border: 1px rgba(207, 207, 207, 0.75) solid;
                  height: 3rem;
                "
              >
                <div class="mdi mdi-shield-check text-semi-large line-height_1 mr-2"></div>
                {{
                  $t('subscription.refund_quarantee', {
                    refund_quarantee_num: 7,
                  })
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="b-dark subcription-section z-index_4">
      <div class="subcription-section_inner mb-8 pt-8 pb-8">
        <h1 class="mx-auto mt-16 f-center mb-8 text-center">
          {{ $t('subscription.faq') }}
        </h1>
        <Faq ref="Faq" />
      </div>
    </div>
    <div class="b-dark subcription-section f-column py-16">
      <div class="subcription-section_inner f-center f-column my-16">
        <div class="title-headline mx-auto text-center px-2">
          {{ $t('subscription.crush_competition') }}
        </div>
        <v-btn
          color="primary"
          size="x-large"
          class="mt-8"
          @click="scrollToPlanBoxes"
        >
          {{ $t('btn.get_started') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Faq from '@/components/Payments/Faq'
// import { seg_track } from '@/helpers/segment'
import Logo from '@/assets/logo.svg'
import PlanBox from '@/components/Payments/PlanBox'
import AllFeaturesTable from '@/components/Payments/AllFeaturesTable'
import AffiliateMessage from '@/components/Payments/AffiliateMessage'

import payment_mix from '@/mixins/payment_mix'
import format_mix from '@/mixins/format_mix'
import tier_mix from '@/mixins/tier_mix'
import { gameModes, getGametypeOrder } from '@/helpers/constants'
import * as R from 'remeda'

export default {
  name: 'SubscriptionOverview',
  components: {
    PlanBox,
    AllFeaturesTable,
    Logo,
    AffiliateMessage,
    Faq,
  },
  mixins: [payment_mix, format_mix, tier_mix],
  data() {
    return {
      animateUnderline: false,
      onceHovered: false,
    }
  },
  mounted() {
    setTimeout(() => {
      this.animateUnderline = true
    }, 400)
    // if (this.gm_type) {
    //   this.trackSegmentGmType()
    // }
  },
  methods: {
    // trackSegmentGmType() {
    //   seg_track('subscriptions_offer_viewed', {
    //     products: [
    //       {
    //         type: this.gm_type.toUpperCase(),
    //       },
    //     ],
    //   })
    // },
    selectgm_type(id) {
      this.$router.replace({ query: { gm_type: id } }).catch(() => {})
      // this.trackSegmentGmType()
    },
    scrollToAnchor() {
      if (this.mobile) {
        const { anchor } = this.$refs
        if (anchor) {
          anchor.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }
    },
    scrollToFeatures() {
      const { featuresTable } = this.$refs
      if (featuresTable?.$el) {
        featuresTable.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    scrollToPlanBoxes() {
      const { planBoxes } = this.$refs
      if (planBoxes) {
        planBoxes.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
  },
  computed: {
    boxPlans() {
      const { gmTier } = this
      const gm_type = this.gm_type || 'cash'

      // console.log(this.plans)

      const starterYrBase = this.plans[gm_type]?.starter?.yearly.options.base
      const cheapestStarterYr = this.plans[gm_type]?.starter?.yearly.cheap

      const premiumYrBase =
        this.plans[gm_type]?.premium.yearly.options.early_bird ||
        this.plans[gm_type]?.premium.yearly.options.base
      const cheapestPremiumYr = this.plans[gm_type]?.premium.yearly.cheap

      const eliteYrBase =
        this.plans[gm_type]?.elite.yearly.options.early_bird ||
        this.plans[gm_type]?.elite.yearly.options.base
      const cheapestEliteYr = this.plans[gm_type]?.elite.yearly.cheap

      const solution_depths_limited = this.$t('table_features.study.x_depths', {
        num: gm_type === 'mtt' ? 5 : gm_type === 'husng' ? 13 : 0,
      })

      const solution_depths_all = this.$t('table_features.study.all_xxx_depths', {
        num: gm_type === 'mtt' ? 'not-used-now' : gm_type === 'husng' ? 48 : '--',
      })
      // TODO unify toolips allFeaturesTable
      const solution_tooltip_depths_limited =
        gm_type === 'mtt'
          ? '14, 25, 35, 60, 80 BB'
          : gm_type === 'husng'
            ? '25, 20, 18, 15, 12, 10, 8, 6, 5, 4, 3, 2, 1 BB'
            : '--'

      const solution_tooltip_depths_all =
        gm_type === 'mtt'
          ? '2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14, 17, 20, 25, 30, 35, 40, 50, 60, 80, 100 BB'
          : gm_type === 'husng'
            ? '1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13.5, 14.5, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 30, 35, 40, 45, 50, 55, 60, 72 BB'
            : gm_type === 'straddle_ante_cash'
              ? '100, 150, 200, 300, 400BB'
              : '--'

      let res = [
        {
          id: 'free',
          title: this.$t('subscription.free.title'),
          subtitle: this.$t('subscription.free.subtitle'),
          features: [
            {
              available_for_types: ['cash'],
              text: this.$t('subscription.free.basic_preflop_solutions'),
              tooltip: {
                text: this.$t('subscription.free.preflop_solutions_tooltip_basic'),
                img: 'features/1.webp',
              },
            },
            {
              available_for_types: ['mtt', 'husng', 'spins', 'straddle_ante_cash'],
              text: this.$t('subscription.free.preflop_solutions'),
              tooltip: {
                text: this.$t('subscription.free.preflop_solutions_tooltip_basic'),
                img: 'features/1.webp',
              },
            },
            {
              text: this.$t('subscription.free.one_postflop', { one_postflop_num: 1 }),
              tooltip: {
                text: this.$t('subscription.free.one_postflop_tooltip', { one_postflop_num: 1 }),
                img: 'features/2.webp',
              },
            },
            {
              text: this.$t('subscription.free.day_10_spots', { day_10_spots_num: 10 }),
              tooltip: {
                text: this.$t('subscription.free.day_10_spots_tooltip', { day_10_spots_num: 10 }),
                img: 'features/3.webp',
              },
            },
            // {
            //   hasTagSoon: true,
            //   text: this.$t('subscription.free.gto_lessons'),
            //   tooltip: {
            //     text: this.$t('subscription.free.gto_lessons_tooltip', { gto_lessons_num: 13 }),
            //     // img: 'img_placeholder.webp',
            //   },
            // },
          ],
          startingAt: false,
          noBold: true,
          isCurrentPlan: true,
          managePlan: false,
          hasEarlyBird: false,
          btnText:
            gmTier === 'TRIAL' || gmTier === 'FREE'
              ? this.$t('payment.current_plan')
              : gmTier === 'STARTER'
                ? this.$t('payment.in_starter')
                : gmTier === 'PREMIUM'
                  ? this.$t('payment.in_premium')
                  : gmTier === 'ELITE'
                    ? this.$t('payment.in_elite')
                    : 'error',
        },
        {
          id: 'starter',
          title: this.$t('subscription.starter.title'),
          subtitle: this.$t('subscription.starter.subtitle'),
          features: [
            {
              text: this.$t('subscription.starter.everything_in_free'),
              css_style: 'font-weight:700',
            },
            {
              available_for_types: ['cash'],
              text: this.$t('table_features.study.all_preflop_solutions'),
            },
            {
              available_for_types: ['cash'],
              text: this.$t('table_features.study.postflop_solutions_xxx', {
                solution_depths: '100BB depth only',
              }),
              tooltip: {
                text: this.$t('subscription.starter.unlimited_postflop_tooltip_tra01', {
                  solution_depths: '100BB depth only',
                }),
                img: 'features/2.webp',
              },
            },
            {
              available_for_types: ['mtt', 'husng'],
              text: this.$t('table_features.study.postflop_solutions_xxx', {
                solution_depths: solution_depths_limited,
              }),
              tooltip: {
                text: solution_tooltip_depths_limited,
                img: 'features/2.webp',
              },
            },
            {
              available_for_types: ['spins'],
              text: this.$t('table_features.study.postflop_solutions_variable_depths', {
                solution_type: `${this.$t('gametypes.groups.husng')}`,
                available_depths: this.$t('table_features.study.x_depths', { num: 13 }),
              }),
              tooltip: {
                text: '25, 20, 18, 15, 12, 10, 8, 6, 5, 4, 3, 2, 1 BB',
                img: 'features/2.webp',
              },
            },
            {
              available_for_types: ['spins'],
              text: this.$t('table_features.study.postflop_solutions_variable_depths', {
                solution_type: `${this.$t('gametypes.groups.spins')}`,
                // available_depths: this.$t('table_features.study.x_depths', { num: 13 }),
                available_depths: this.$t('gametypes.SYMMETRIC'),
              }),
              tooltip: {
                // text: '25, 19, 16, 15, 12, 10, 8, 6, 5, 4, 3, 2, 1 BB',
                text: this.$t(`tooltips.what_are_symmetric_stacks`),
                img: 'features/2.webp',
              },
            },
            {
              available_for_types: ['spins'],
              text: this.$t('table_features.study.postflop_solutions_variable_depths', {
                solution_type: `${this.$t('gametypes.groups.spins_ante')}`,
                // available_depths: this.$t('table_features.study.x_depths', { num: 13 }),
                available_depths: this.$t('gametypes.SYMMETRIC'),
              }),
              tooltip: {
                // text: '25, 19, 16, 15, 12, 10, 8, 6, 5, 4, 3, 2, 1 BB',
                text: `${this.$t(`tooltips.what_are_symmetric_stacks`)} <br> (Ante is 0.17bb)`,
                img: 'features/2.webp',
              },
            },
            {
              available_for_types: ['cash'],
              text: this.$t('subscription.starter.unlimited_practice_xxx', {
                solution_depths: '100BB depth',
              }),
              tooltip: {
                text: this.$t('subscription.starter.unlimited_practice_tooltip_xxx', {
                  solution_depths: '100BB depth',
                }),
                img: 'features/3.webp',
              },
            },
            {
              available_for_types: ['mtt', 'husng'],
              text: this.$t('subscription.starter.unlimited_practice_xxx', {
                solution_depths: solution_depths_limited,
              }),
              tooltip: {
                text: this.$t('subscription.starter.unlimited_practice_tooltip_xxx', {
                  solution_depths: solution_depths_limited,
                }),
                img: 'features/3.webp',
              },
            },
            {
              available_for_types: ['spins'],
              text: this.$t('subscription.starter.unlimited_practice_xxx', {
                solution_depths: '13 depths + Symmetric',
              }),
              tooltip: {
                text: this.$t('subscription.starter.unlimited_practice_tooltip_xxx', {
                  solution_depths: '13 depths + Symmetric',
                }),
                img: 'features/3.webp',
              },
            },
            {
              text: this.$t('subscription.starter.month_50_hands', { month_50_hands_num: 50 }),
              tooltip: {
                text: this.$t('subscription.starter.month_50_hands_tooltip', {
                  month_50_hands_num: 50,
                }),
                img: 'features/4.webp',
              },
            },
            {
              text: this.$t('subscription.starter.basic_aggregated_reports'),
              tooltip: {
                text: this.$t('subscription.starter.basic_aggregated_reports_tooltip_tra01', {
                  flop_available_spots: 3,
                }),
              },
            },
          ],
          // hasEarlyBird: cheapestStarterYr?.price_type?.toLowerCase() === 'early_bird',
          seg_plan: cheapestStarterYr,
          startingAt: cheapestStarterYr?.price / 12,
          normalPrice:
            cheapestStarterYr?.price !== starterYrBase?.price ? cheapestStarterYr?.price / 12 : '',
          isCurrentPlan: gmTier === 'STARTER' || gmTier === 'PREMIUM' || gmTier === 'ELITE',
          managePlan: gmTier === 'STARTER',
          btnText:
            gmTier === 'TRIAL' || gmTier === 'FREE'
              ? this.$t('payment.get_started')
              : gmTier === 'STARTER'
                ? this.$t('payment.manage_plan')
                : gmTier === 'PREMIUM'
                  ? this.$t('payment.in_premium')
                  : gmTier === 'ELITE'
                    ? this.$t('payment.in_elite')
                    : this.$t('payment.upgrade_plan'),
        },
        {
          id: 'premium',
          title: this.$t('subscription.premium.title'),
          subtitle: this.$t('subscription.premium.subtitle'),
          features: [
            {
              available_for_types: ['straddle_ante_cash'],
              text: this.$t('table_features.study.all_preflop_solutions'),
            },
            {
              available_for_types: ['straddle_ante_cash'],
              text: this.$t('table_features.study.postflop_6max_8max_straddle_ante'),
            },
            {
              available_for_types: ['mtt', 'husng', 'cash', 'spins'],
              text: this.$t('subscription.premium.everything_in_starter'),
              css_style: 'font-weight:700',
            },

            {
              available_for_types: ['mtt'],
              text: this.$t('table_features.study.headsup_solutions'),
            },
            {
              available_for_types: ['mtt'],
              text: this.$t('table_features.study.icm_solutions_all_xxx_situations', {
                num: '9000+',
              }),
              tooltip: {
                // text: this.$t('table_features.study.blockers_score_tooltip'),
                text: this.$t('tooltips.mtt_icm_solutions'),
              },
            },
            {
              available_for_types: ['mtt'],
              text: this.$t('table_features.study.icm_pko_solutions_all_xxx_situations', {
                num: '1500+',
              }),
              tooltip: {
                text: this.$t('tooltips.mtt_icm_pko_solutions', { num: '1500+' }),
              },
            },
            {
              available_for_types: ['mtt'],
              text: this.$t('table_features.study.postflop_solutions_xxx', {
                solution_depths: 'All depths',
              }),
              tooltip: {
                text: '6max and 8max symmetric and mixed stack sizes.',
                img: 'features/2.webp',
              },
            },

            {
              available_for_types: ['husng'],
              text: this.$t('table_features.study.postflop_solutions_xxx', {
                solution_depths: solution_depths_all,
              }),
              tooltip: {
                text: solution_tooltip_depths_all,
                img: 'features/2.webp',
              },
            },
            {
              available_for_types: ['cash'],
              text: this.$t('table_features.study.postflop_solutions_variable_depths', {
                available_depths: this.$t('table_features.study.all_depths'),
              }),
              tooltip: {
                text: '20, 40, 50, 75, 100, 150, 200 BB',
                img: 'features/2.webp',
              },
            },

            {
              text: this.$t('table_features.study.blockers_score'),
              tooltip: {
                text: this.$t('table_features.study.blockers_score_tooltip'),
              },
            },
            {
              available_for_types: ['spins'],
              text: this.$t('table_features.study.postflop_solutions_variable_depths', {
                solution_type: `${this.$t('gametypes.groups.husng')}`,
                available_depths: this.$t('table_features.study.all_depths'),
              }),
              tooltip: {
                text: '25, 22.5, 20, 18, 16, 15, 14.5, 14, 13.5, 13, 12.5, 12, 11.5, 11, 10.5, 10, 9.5, 9, 8.5, 8, 7.5, 7, 6.5, 6, 5.5, 5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1 BB',
                img: 'features/2.webp',
              },
            },
            {
              available_for_types: ['spins'],
              text: this.$t('table_features.study.postflop_solutions_variable_depths', {
                solution_type: `${this.$t('gametypes.groups.spins')}`,
                available_depths: this.$t('table_features.study.all_depths'),
              }),
              tooltip: {
                text: '35, 34, 33, 32, 31, 30, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 16, 15, 14, 13, 12, 11, 10, 9.5, 9, 8.5, 8, 7.5, 7, 6.5, 6, 5.5, 5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1',
                img: 'features/2.webp',
              },
            },
            {
              available_for_types: ['spins'],
              text: this.$t('table_features.study.postflop_solutions_variable_depths', {
                solution_type: `${this.$t('gametypes.groups.spins_ante')}`,
                available_depths: this.$t('table_features.study.all_depths'),
              }),
              tooltip: {
                text: '24, 23, 22, 21, 20, 19, 18, 17, 16, 15, 14, 13, 12, 11, 10, 9.5, 9, 8.5, 8, 7.5, 7, 6.5, 6, 5.5, 5, 4.5, 4, 3.5, 3, 2.5, 2, 1.5, 1. (Ante is 0.17bb)',
                img: 'features/2.webp',
              },
            },
            {
              available_for_types: ['spins'],
              text: this.$t('table_features.study.posflop_solutions_mixed_stacks_simple', {
                solution_type: `${this.$t('gametypes.groups.spins')}`,
              }),
              tooltip: {
                // img: 'features/bigger/varying_stacks.webp',
                text: this.$t('tooltips.what_is_varying_stacks_solutions'),
              },
            },
            {
              text: this.$t('subscription.premium.month_100000_hands', {
                premium_hands_mo_num: (100000).toLocaleString(this.$i18n.locale),
              }),
              tooltip: {
                text: this.$t('subscription.premium.month_100000_hands_tooltip', {
                  premium_hands_mo_num: (100000).toLocaleString(this.$i18n.locale),
                }),
                img: 'features/4.webp',
              },
            },
            {
              hasTagSoon: true,
              available_for_types: ['mtt', 'husng', 'cash'],
              //  available_for_types: ['mtt', 'husng', 'cash', 'spins'],
              text: this.$t('subscription.starter.hh_reports_tra01'),
              tooltip: {
                text: this.$t('subscription.starter.hh_reports_tra01_tooltip'),
              },
            },
            {
              available_for_types: ['straddle_ante_cash'],
              text: this.$t('table_features.study.flop_turn_agg_reports'),
              tooltip: {
                text: this.$t('table_features.study.aggregated_reports_tooltip'),
              },
            },
            {
              text: this.$t('table_features.study.weekly_coachings'),
              tooltip: {
                text: this.$t('table_features.study.weekly_coachings_tooltip'),
                img: 'features/bigger/10.webp',
              },
            },
          ],
          seg_plan: cheapestPremiumYr,
          startingAt: cheapestPremiumYr?.price / 12,
          affiliate: cheapestPremiumYr?.price_type === 'AFFILIATE',
          normalPrice:
            cheapestPremiumYr?.price !== premiumYrBase?.price ? premiumYrBase?.price / 12 : '',
          isCurrentPlan: gmTier === 'PREMIUM' || gmTier === 'ELITE',
          managePlan: gmTier === 'PREMIUM',
          btnText:
            gmTier === 'TRIAL' || gmTier === 'FREE'
              ? this.$t('payment.get_started')
              : gmTier === 'PREMIUM'
                ? this.$t('payment.manage_plan')
                : gmTier === 'ELITE'
                  ? this.$t('payment.in_elite')
                  : this.$t('payment.upgrade_plan'),
        },
        {
          id: 'elite',
          title: this.$t('subscription.elite.title'),
          subtitle: this.$t('subscription.elite.subtitle'),
          features: [
            {
              available_for_types: ['mtt', 'husng', 'cash', 'spins', 'straddle_ante_cash'],
              text: this.$t('subscription.elite.everything_in_premium'),
              css_style: 'font-weight:700',
            },
            {
              available_for_types: ['mtt', 'husng', 'cash', 'spins', 'straddle_ante_cash'],
              text: this.$t('subscription.elite.ai_solving_all'),
              tooltip: {
                text: this.$t('table_features.ai_solving_tooltip', {
                  ...(!this.$i18n.g1
                    ? {
                        link: this.$t('common.link_text', {
                          url: 'https://blog.gtowizard.com/introducing-gto-wizard-ai/',
                          text: this.$t('common.read_more'),
                          cssClass: 'text-underline_hover hover_lighted',
                        }),
                      }
                    : {}),
                }),
              },
            },
            {
              text: this.$t('table_features.nodelocking'),
              tooltip: {
                text: this.$t('table_features.nodelocking_tooltip'),
              },
            },
            {
              text: this.$t('table_features.dynamic_ev_sizings'),
              tooltip: {
                text: this.$t('table_features.dynamic_ev_sizings_tooltip'),
              },
            },
            {
              text: this.$t('subscription.premium.month_100000_hands', {
                premium_hands_mo_num: (150000).toLocaleString(this.$i18n.locale),
              }),
              tooltip: {
                text: this.$t('subscription.premium.month_100000_hands_tooltip', {
                  premium_hands_mo_num: (150000).toLocaleString(this.$i18n.locale),
                }),
                img: 'features/4.webp',
              },
            },

            {
              hasTagSoon: true,
              available_for_types: ['mtt', 'husng', 'cash'],
              //  available_for_types: ['mtt', 'husng', 'cash', 'spins'],
              text: this.$t('subscription.starter.hh_reports_advanced'),
              tooltip: {
                text: this.$t('subscription.starter.hh_reports_advanced_tooltip'),
              },
            },
            {
              available_for_types: ['mtt'],
              text: this.$t('subscription.elite.custom_solving_with_icm'),
            },
            {
              available_for_types: ['cash', 'straddle_ante_cash'],
              text: this.$t('subscription.starter.custom_rake_solving'),
              tooltip: {
                text: this.$t('subscription.starter.custom_rake_solving_tooltip'),
              },
            },
          ].filter(i => i),
          seg_plan: cheapestEliteYr,
          hasAiBtnSlot: true,
          affiliate: cheapestEliteYr?.price_type === 'AFFILIATE',
          startingAt: cheapestEliteYr?.price / 12,
          normalPrice: cheapestEliteYr?.price !== eliteYrBase?.price ? eliteYrBase?.price / 12 : '',
          isCurrentPlan: gmTier === 'ELITE',
          managePlan: gmTier === 'ELITE',
          btnText:
            gmTier === 'TRIAL' || gmTier === 'FREE'
              ? this.$t('payment.get_started')
              : gmTier === 'ELITE'
                ? this.$t('payment.manage_plan')
                : this.$t('payment.upgrade_plan'),
        },
      ]
      res = res.map(i => {
        const aaa = i.features.find(f => f.available_for_types)
        if (aaa) {
          const features = i.features.filter(f =>
            f.available_for_types ? f.available_for_types.includes(gm_type) : true,
          )
          return {
            ...i,
            features,
          }
        }
        return i
      })

      if (this.gmStraddle) {
        res = [res[0], res[2], res[3]].map(i => {
          if (i.id === 'premium') {
            return {
              ...i,
              // style_rounded: true,
              css_style: 'border-radius:8px 0 0 8px;margin:0 auto; border-left:none',
            }
          }
          if (i.id === 'elite') {
            return {
              ...i,
              // style_rounded: true,
              css_style: 'border-radius:0 8px 8px 0;margin:0 auto;',
            }
          }
          return {
            renderSlot: true,
          }
        })
      }
      // if (this.gmEliteOnly) {
      //   res = [res[0], res[2]].map(i => {
      //     if (i.id === 'premium') {
      //       return {
      //         ...i,
      //         style_rounded: true,
      //         css_style: 'max-width:21rem;border-radius:8px;margin:0 auto;',
      //       }
      //     }
      //     return {
      //       renderSlot: true,
      //     }
      //   })
      // }
      // console.log({
      //   res,
      //   starterYrBase,
      //   cheapestStarterYr,
      //   premiumYrBase,
      //   cheapestPremiumYr,
      //   eliteYrBase,
      //   cheapestEliteYr,
      //   plans: this.plans,
      // })
      return res
    },
    user_info() {
      const { user_info } = this.$store.getters
      return user_info
    },
    smallScreen() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 768
    },
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
    groups() {
      const order = getGametypeOrder()
      return R.pipe(
        gameModes,
        R.map(i => ({
          id: i,
          display_name: this.$t(`gametypes.groups.${i}_long`),
        })),
        R.sort((a, b) => (order.indexOf(a.id) < order.indexOf(b.id) ? -1 : 1)),
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .plan-boxes-top {
    flex-direction: column;
    .plan-box {
      margin: 0.5rem 0 !important;
      border-radius: 8px !important;
      border: none !important;
    }
  }
  .moved-left {
    margin-left: unset !important;
  }
  .gameformat-groups_group {
    min-width: 100%;
  }

  .focus-here {
    top: 44rem !important;
  }

  .gameformat-groups {
    grid-template-columns: 1fr !important;
  }
  .groups-sticky {
    &:before {
      height: calc(100% + 48rem) !important;
    }
  }
}
@media (max-width: 767px) {
  .plan-boxes {
    flex-direction: column;
    .plan-box {
      margin: 0.5rem 0 !important;
      border-radius: 8px !important;
      border: none !important;
    }
  }
  .anim-underline {
    &:before {
      bottom: -3px !important;
    }
  }
}

.inner_straddle_ante_cash {
  // max-width: 63rem !important;
  max-width: 76rem !important;
}

.tier-tag-straddle {
  border-radius: 99px;
  background: rgb(0, 0, 0, 0.7);
}

.groups-sticky {
  position: sticky;
  top: 0;
  z-index: 4;

  &:before {
    content: '';
    height: 3rem;
    width: calc(100% + 4rem);
    height: calc(100% + 32rem);
    top: 0;
    left: -2rem;
    background: linear-gradient(var(--clr-subscription-back) 15%, transparent);
    position: absolute;
    z-index: 0;
  }
}

.focus-here {
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  // top: 15rem;
  top: 19rem;
  bottom: 0.65rem;
  font-size: 1.5rem;
  font-weight: 800;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  .arrow-up {
    border: solid var(--clr-primary);
    border-width: 0 6px 6px 0;
    padding: 6px;
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
    animation: upFade 2s ease-in-out infinite;
    position: relative;
    z-index: 1;
  }
  &::before {
    content: '';
    height: 3rem;
    width: 22rem;
    border-radius: 4px;
    position: absolute;
    z-index: 0;
  }
}

@keyframes upFade {
  0% {
    opacity: 0;
    transform: translateY(12px) rotate(-135deg);
  }
  50% {
    opacity: 1;
    transform: translateY(0px) rotate(-135deg);
  }
  100% {
    opacity: 0;
    transform: translateY(-8px) rotate(-135deg);
  }
}

.gameformat-groups {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  // grid-template-columns: repeat(3, 1fr);
  grid-gap: 0.5rem;
  align-items: center;
  justify-content: center;
  .group-free {
    color: var(--clr-grey-2);
  }
  &_group {
    position: relative;
    --percent: -500%;
    --clr-type: var(--clr-primary);
    --clr-back: transparent;
    transition: 0.2s;
    &:after {
      content: '';
      height: 8px;
      width: 100%;
      background: currentColor;
      bottom: 0;
      position: absolute;
      left: 0;
      transition: 0.2s;
      border-radius: 2px;
    }
    &:before {
      content: '';
      height: 100%;
      width: 100%;
      background: var(--clr-back);
      background: transparent;
      bottom: 0;
      position: absolute;
      left: 0;
      z-index: 0;
      transition: 0.2s;
      border-radius: 8px;
    }
    color: var(--clr-white-0);
    margin-top: 1rem;
    letter-spacing: 0.5px;
    font-weight: 700;
    font-size: 2rem;
    padding: 1rem 1.5rem;
    text-transform: uppercase;
    flex: 1;
    white-space: nowrap;
    cursor: pointer;
    position: relative;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    &:hover {
      &:before {
        background: rgba(255, 255, 255, 0.075);
      }
      &:after {
        background: var(--clr-type);
      }
    }
    &_title-top {
      text-wrap: nowrap;
      position: absolute;
      font-size: 0.8rem;
      top: -0.7rem;
      letter-spacing: 1.25px;
      right: 0;
    }
  }
  .gm-active {
    &:before {
      background: rgba(255, 255, 255, 0.075);
    }
    &:after {
      background: var(--clr-type);
    }
  }
}

.b-dark {
  background: var(--clr-subscription-back);
}
.title-headline {
  font-size: 2.5rem;
  font-weight: 700;
}
.moved-left {
  margin-left: 20rem;
}
.plan-boxes {
  display: flex;
  // margin: 1rem 0;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  &_left {
    @extend .moved-left;
  }
  .plan-box {
    flex: 1;
    &:nth-child(2) {
      border-left: solid grey 1px;
      border-right: solid grey 1px;
    }
    &:nth-child(3) {
      border-right: solid grey 1px;
    }
  }
}
.logo {
  color: var(--clr-white-0);
  fill: currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  flex-shrink: 0;
  svg {
    width: 8rem;
  }
}
.feature-list {
  // opacity: 0.8;
  color: var(--clr-grey-2);
  padding: 1rem;
  cursor: pointer;
  font-weight: 500;
  transition: 0.2s;
  &:hover {
    filter: brightness(1.2);
  }
  i {
    color: var(--clr-grey-2);
  }
}

.refund-message {
  font-size: 1.5rem;
  font-weight: 700;
  padding: 2rem;
  text-align: center;
  height: var(--vh-100);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .icon-logo {
    &_icon {
      font-size: 12rem !important;
      color: var(--clr-black-1) !important;
    }
  }
}

.anim-underline {
  position: relative;
  overflow: hidden;
  --clr: var(--clr-primary);
  &_text {
    position: relative;
    z-index: 2;
  }
  &:before {
    content: '';
    transition: 0.2s;
    background: var(--clr);
    height: 8px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 1;
    animation: fullWidth 0.8s ease-in-out;
    animation: fullWidth 0.8s cubic-bezier(0.48, 0, 0, 1.34);
  }
}

@keyframes fullWidth {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}
</style>
